import type { FaireProductEntity } from "../../entity_types/product";

export const p_c9orvefo9d: FaireProductEntity = {
  token: "p_c9orvefo9d",
  type: "product",
  name: "Tea Tree Organic Body Wash and Shampoo - fungal / candida",
  brandToken: "b_129dsr49u5",
  brandName: "Taylor Made Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/2e42bd9d7add31bf77c1dd7e6770f712f4727602caa105701efdca751863df42.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/554677ff3f791d47f860dac9fd9cbabf9c93f79e03f299156c734f42fdc908a1.png",
    "https://cdn.faire.com/fastly/328f522efb9c9436a6f315bbd877ca834d0c4f7a4d6a7abe7fd28f6b171c398e.png",
  ],
  priceDollars: 12.5,
  description:
    "Our Tea Tree Organic Body Wash and Shampoo is perfect for fighting fungal and candida infections. Sulfate-free and made with tea tree, lemon, and rosemary essential oils, this product is perfect for hygienic and healthy skin. Enjoy a refreshing and naturally invigorating clean!\n\n8 fl oz net wt.\n\nHow to use \nThis product can be used as a body wash or shampoo. Apply a small amount of cleanser to your hands or cloth and rub in a circular motion. Cleanse skin. Rinse with warm water and pat dry. Follow up with our Tea Tree Cream. Use as needed.\n\nwater, *aloe vera juice, +decyl glucoside, +lauryl glucoside, +xanthan gum, +potassium sorbate, +sodium benzoate, +citric acid, extracts of *lemon balm, *thyme, and *pau d’ arco, essential oils of *tea tree, *lemon, *rosemary, *oregano, *lavender, and *thyme, and +phenoxyethanol&nbsp;\n\nMade in the USA | *Certified Organic +Plant-based | Vegan | Paraben-Free | Sulfate-Free | Fragrance-Free | Cruelty-Free | Gluten-Free | Toxin-Free",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:27.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
